import Explainer from '../blocks';

import styles from './UniversalFormat.module.css';

const EXPLAINER_WIDTH = 1280;
const EXPLAINER_HEIGHT = 700;

const UniversalFormat = () => {
  return (
    <Explainer
      width={EXPLAINER_WIDTH}
      height={EXPLAINER_HEIGHT}
      className={styles.root}
      once
    >
      <g className={styles.description}>
        <g transform="translate(36, 125)">
          <text
            fill="white"
            fontFamily="var(--font-family-mono)"
            fontSize="16"
            letterSpacing="0.005em"
          >
            <tspan x="59.1244" y="383.1">
              Use any format in{' '}
            </tspan>
            <tspan x="78.8956" y="406.1">
              your repository
            </tspan>
          </text>
          <text
            fill="white"
            fontFamily="var(--font-family-mono)"
            fontSize="16"
            letterSpacing="0.005em"
          >
            <tspan x="29.5875" y="207.1">
              Quickly troubleshoot{' '}
            </tspan>
            <tspan x="9.97626" y="230.1">
              vulnerabilties or risk
            </tspan>
          </text>
          <text
            fill="white"
            fontFamily="var(--font-family-mono)"
            fontSize="16"
            letterSpacing="0.005em"
          >
            <tspan x="59.1244" y="17.1">
              Easily manage all{' '}
            </tspan>
            <tspan x="39.4331" y="40.1">
              packages, upstreams{' '}
            </tspan>
            <tspan x="108.433" y="63.1">
              and settings
            </tspan>
          </text>
          <line
            x1="252"
            y1="388.25"
            x2="303"
            y2="388.25"
            stroke="#FD93A8"
            strokeWidth="1.5"
            strokeDasharray="2 2"
          />
          <line
            x1="252"
            y1="212.25"
            x2="303"
            y2="212.25"
            stroke="#FD93A8"
            strokeWidth="1.5"
          />
          <line
            x1="252"
            y1="23.25"
            x2="303"
            y2="23.25"
            stroke="#FD93A8"
            strokeWidth="1.5"
            strokeDasharray="2 2"
          />
        </g>
      </g>

      <g className={styles.ui}>
        <g transform="translate(308, 40)">
          <g
            clipPath="url(#clip0_3584_7073)"
            filter="url(#filter0_d_3584_7073)"
          >
            <rect
              width="945"
              height="645"
              transform="translate(30 15)"
              fill="white"
            />
            <text
              fill="#8497A2"
              fontFamily="var(--font-family-body)"
              fontSize="14"
              letterSpacing="0.0075em"
            >
              <tspan x="94" y="303.66">
                Quick Filters
              </tspan>
            </text>
            <rect x="192" y="279" width="120" height="38" rx="6" fill="white" />
            <rect
              x="192.5"
              y="279.5"
              width="119"
              height="37"
              rx="5.5"
              stroke="#092F45"
              strokeOpacity="0.1"
              fill="white"
            />
            <text
              fill="#EEC26F"
              fontFamily="var(--font-family-mono)"
              fontSize="16"
              letterSpacing="-0.0025em"
            >
              <tspan x="206.5" y="303.6">
                2
              </tspan>
            </text>
            <text
              fill="#092F45"
              fontFamily="var(--font-family-body)"
              fontSize="14"
              letterSpacing="0.0075em"
            >
              <tspan x="224.5" y="302.66">
                Quarantined
              </tspan>
            </text>
            <path
              d="M192 285C192 281.686 194.686 279 198 279V279V317V317C194.686 317 192 314.314 192 311V285Z"
              fill="#EEC26F"
            />
            <rect x="324" y="279" width="118" height="38" rx="6" fill="white" />
            <rect
              x="324.5"
              y="279.5"
              width="117"
              height="37"
              rx="5.5"
              stroke="#092F45"
              strokeOpacity="0.1"
              fill="white"
            />
            <text
              fill="#B73B55"
              fontFamily="var(--font-family-mono)"
              fontSize="16"
              letterSpacing="-0.0025em"
            >
              <tspan x="337.5" y="303.6">
                1
              </tspan>
            </text>
            <text
              fill="#092F45"
              fontFamily="var(--font-family-body)"
              fontSize="14"
              letterSpacing="0.0075em"
            >
              <tspan x="355.5" y="302.66">
                Vulnerability
              </tspan>
            </text>
            <path
              d="M324 285C324 281.686 326.686 279 330 279V279V317V317C326.686 317 324 314.314 324 311V285Z"
              fill="#B73B55"
            />
            <rect
              x="454.5"
              y="279.5"
              width="217"
              height="37"
              rx="5.5"
              fill="#FAFBFB"
            />
            <rect
              x="454.5"
              y="279.5"
              width="217"
              height="37"
              rx="5.5"
              stroke="#E6EAEC"
              fill="white"
            />
            <text
              fill="#5F7886"
              fontFamily="var(--font-family-mono)"
              fontSize="16"
              letterSpacing="-0.0025em"
            >
              <tspan x="464.5" y="303.6">
                0
              </tspan>
            </text>
            <text
              fill="#5F7886"
              fontFamily="var(--font-family-body)"
              fontSize="14"
              letterSpacing="0.0075em"
            >
              <tspan x="482.5" y="302.66">
                Vulnerability Policy Violations
              </tspan>
            </text>
            <rect
              x="684.5"
              y="279.5"
              width="191"
              height="37"
              rx="5.5"
              fill="#FAFBFB"
            />
            <rect
              x="684.5"
              y="279.5"
              width="191"
              height="37"
              rx="5.5"
              stroke="#E6EAEC"
              fill="white"
            />
            <text
              fill="#5F7886"
              fontFamily="var(--font-family-mono)"
              fontSize="16"
              letterSpacing="-0.0025em"
            >
              <tspan x="696" y="303.6">
                0
              </tspan>
            </text>
            <text
              fill="#5F7886"
              fontFamily="var(--font-family-body)"
              fontSize="14"
              letterSpacing="0.0075em"
            >
              <tspan x="714" y="302.66">
                License Policy Violations
              </tspan>
            </text>
            <rect
              x="888.5"
              y="279.5"
              width="71"
              height="37"
              rx="5.5"
              stroke="#EAF1FC"
              fill="white"
            />
            <text
              fill="#092F45"
              fontFamily="var(--font-family-body)"
              fontSize="14"
              letterSpacing="0.0075em"
            >
              <tspan x="899" y="302.66">
                Pending
              </tspan>
            </text>
            <rect x="30" y="15" width="945" height="73" fill="#FAFCFD" />
            <text
              fill="#092F45"
              fontFamily="var(--font-family-body)"
              fontSize="16"
              letterSpacing="0.005em"
            >
              <tspan x="149.883" y="55.64">
                Workspace
              </tspan>
            </text>
            <text
              opacity="0.15"
              fill="#092F45"
              fontFamily="var(--font-family-body)"
              fontSize="18"
              letterSpacing="0em"
            >
              <tspan x="249.883" y="56.22">
                /
              </tspan>
            </text>
            <text
              fill="#092F45"
              fontFamily="var(--font-family-body)"
              fontSize="16"
              letterSpacing="0.005em"
            >
              <tspan x="279.883" y="55.64">
                Repository
              </tspan>
            </text>
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M122 49.4446V52.5557L110 65.0002H107L95 52.5557V49.4446L107 37.0002H110L122 49.4446ZM108.5 57.4582C111.939 57.4582 114.727 54.567 114.727 51.0006C114.727 47.4342 111.939 44.543 108.5 44.543C105.061 44.543 102.273 47.4342 102.273 51.0006C102.273 54.567 105.061 57.4582 108.5 57.4582Z"
              fill="#092F45"
            />
            <mask id="path-25-inside-1_3584_7073" fill="white">
              <path d="M30 77H975V137H30V77Z" />
            </mask>
            <path d="M30 77H975V137H30V77Z" fill="#FAFCFD" />
            <path
              d="M975 136H30V138H975V136Z"
              fill="#092F45"
              fillOpacity="0.1"
              mask="url(#path-25-inside-1_3584_7073)"
            />
            <mask id="path-27-inside-2_3584_7073" fill="white">
              <path d="M95 77H164V137H95V77Z" />
            </mask>
            <path
              d="M164 133H95V141H164V133Z"
              fill="#2A6FE1"
              mask="url(#path-27-inside-2_3584_7073)"
            />
            <text
              fill="#092F45"
              fontFamily="var(--font-family-body)"
              fontSize="16"
              letterSpacing="0.005em"
            >
              <tspan x="96" y="111.64">
                Packages
              </tspan>
            </text>
            <text
              fill="#8497A2"
              fontFamily="var(--font-family-body)"
              fontSize="16"
              letterSpacing="0.005em"
            >
              <tspan x="189" y="111.64">
                Upstreams
              </tspan>
            </text>
            <text
              fill="#8497A2"
              fontFamily="var(--font-family-body)"
              fontSize="16"
              letterSpacing="0.005em"
            >
              <tspan x="292" y="111.64">
                Settings
              </tspan>
            </text>
            <path
              d="M100 341.5H974.5V446.5H94.5V347C94.5 343.962 96.9624 341.5 100 341.5Z"
              fill="#FAFCFC"
              stroke="#E2E7EA"
            />
            <text
              fill="#092F45"
              stroke="#E2E7EA"
              strokeWidth="0.282736"
              fontFamily="var(--font-family-headline)"
              fontSize="16"
              letterSpacing="0em"
            >
              <tspan x="150" y="382.6">
                189,000 Packages
              </tspan>
            </text>
            <rect
              x="118.5"
              y="369.383"
              width="15"
              height="15"
              rx="3.5"
              stroke="#E2E7EA"
              fill="white"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M302.586 376.856L303.293 376.149L307.402 380.258H308.722L312.701 376.154L313.419 376.85L309.145 381.258H306.988L302.586 376.856Z"
              fill="#8497A2"
            />
            <text
              fill="#5F7886"
              fontFamily="var(--font-family-body)"
              fontSize="12.5"
              letterSpacing="0.03em"
            >
              <tspan x="321" y="382.078">
                Total Downloads
              </tspan>
            </text>
            <text
              fill="#8497A2"
              fontFamily="var(--font-family-body)"
              fontSize="14"
              letterSpacing="0.0075em"
            >
              <tspan x="843" y="379.92">
                Group packages
              </tspan>
            </text>
            <rect
              x="953"
              y="367"
              width="32"
              height="18"
              rx="9"
              fill="#2A6FE1"
              fillOpacity="0.1"
            />
            <rect
              x="953.5"
              y="367.5"
              width="31"
              height="17"
              rx="8.5"
              stroke="#2A6FE1"
              strokeOpacity="0.1"
              fill="white"
            />
            <rect
              x="955"
              y="369"
              width="14"
              height="14"
              rx="7"
              fill="#5F7886"
            />
            <path
              d="M94.5 446.5H974.5V659.5H94.5V446.5Z"
              stroke="#E2E7EA"
              fill="white"
            />
            <line
              x1="95.0859"
              y1="548.343"
              x2="974.086"
              y2="548.343"
              stroke="#092F45"
              strokeOpacity="0.05"
            />
            <line
              x1="95.0859"
              y1="651.343"
              x2="974.086"
              y2="651.343"
              stroke="#092F45"
              strokeOpacity="0.05"
            />
            <line
              x1="95.0859"
              y1="600.343"
              x2="974.086"
              y2="600.343"
              stroke="#092F45"
              strokeOpacity="0.05"
            />
            <line
              x1="95.0859"
              y1="497.343"
              x2="974.086"
              y2="497.343"
              stroke="#092F45"
              strokeOpacity="0.05"
            />
            <line
              x1="665.5"
              y1="447"
              x2="665.5"
              y2="660"
              stroke="#092F45"
              strokeOpacity="0.05"
            />
            <text
              fill="#092F45"
              fontFamily="var(--font-family-body)"
              fontSize="16"
              letterSpacing="0.005em"
            >
              <tspan x="184.25" y="581.14">
                sinatra
              </tspan>
            </text>
            <text
              fill="#5F7886"
              fontFamily="var(--font-family-mono)"
              fontSize="14"
              letterSpacing="0.0075em"
            >
              <tspan x="238.25" y="581.4">
                @3.1.1
              </tspan>
            </text>
            <path
              d="M303.144 569.606L305.354 569.609L311.119 575.369L311.119 577.624L305.358 583.392L303.141 583.391L297.375 577.618L297.375 575.39L303.144 569.606Z"
              fill="#85DABB"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M304.144 579.452L307.819 574.735L307.324 574.349L303.837 578.823L303.407 578.823L301.271 576.41L300.801 576.826L303.124 579.452L304.144 579.452Z"
              fill="white"
              stroke="white"
              strokeWidth="0.3"
            />
            <text
              fill="#092F45"
              fontFamily="var(--font-family-body)"
              fontSize="16"
              letterSpacing="0.005em"
            >
              <tspan x="184.25" y="528.14">
                sinatra
              </tspan>
            </text>
            <text
              fill="#5F7886"
              fontFamily="var(--font-family-mono)"
              fontSize="14"
              letterSpacing="0.0075em"
            >
              <tspan x="238.25" y="528.4">
                @3.1.0
              </tspan>
            </text>
            <path
              d="M303.144 516.606L305.354 516.609L311.119 522.369L311.119 524.624L305.358 530.392L303.141 530.391L297.375 524.618L297.375 522.39L303.144 516.606Z"
              fill="#85DABB"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M304.144 526.452L307.819 521.735L307.324 521.349L303.837 525.823L303.407 525.823L301.271 523.41L300.801 523.826L303.124 526.452L304.144 526.452Z"
              fill="white"
              stroke="white"
              strokeWidth="0.3"
            />
            <text
              fill="#092F45"
              fontFamily="var(--font-family-body)"
              fontSize="16"
              letterSpacing="0.005em"
            >
              <tspan x="184.25" y="632.14">
                sinatra
              </tspan>
            </text>
            <text
              fill="#5F7886"
              fontFamily="var(--font-family-mono)"
              fontSize="14"
              letterSpacing="0.0075em"
            >
              <tspan x="238.25" y="632.4">
                @3.1.2
              </tspan>
            </text>
            <path
              d="M303.144 620.606L305.354 620.609L311.119 626.369L311.119 628.624L305.358 634.392L303.141 634.391L297.375 628.618L297.375 626.39L303.144 620.606Z"
              fill="#85DABB"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M304.144 630.452L307.819 625.735L307.324 625.349L303.837 629.823L303.407 629.823L301.271 627.41L300.801 627.826L303.124 630.452L304.144 630.452Z"
              fill="white"
              stroke="white"
              strokeWidth="0.3"
            />
            <path
              opacity="0.9"
              d="M151.469 565.684C150.655 565.684 150 566.339 150 567.153V584.214C150 585.029 150.655 585.684 151.469 585.684H168.531C169.345 585.684 170 585.029 170 584.214V567.153C170 566.339 169.345 565.684 168.531 565.684H151.469ZM154.275 570.119L165.806 570.135L165.798 581.665H162.912L162.92 573.014H160.04L160.033 581.659H154.261L154.275 570.119Z"
              fill="#092F45"
            />
            <path
              opacity="0.9"
              d="M151.469 512.684C150.655 512.684 150 513.339 150 514.153V531.214C150 532.029 150.655 532.684 151.469 532.684H168.531C169.345 532.684 170 532.029 170 531.214V514.153C170 513.339 169.345 512.684 168.531 512.684H151.469ZM154.275 517.119L165.806 517.135L165.798 528.665H162.912L162.92 520.014H160.04L160.033 528.659H154.261L154.275 517.119Z"
              fill="#092F45"
            />
            <path
              opacity="0.9"
              d="M154.007 461.833C153.747 461.822 153.453 461.893 153.317 462.214C153.185 462.526 153.081 463.204 153.034 464.111L154.053 464.603C154.036 463.989 154.059 463.411 154.116 462.881C154.094 463.131 154.069 463.681 154.121 464.581C154.137 464.866 154.162 465.185 154.194 465.539C154.196 465.559 154.196 465.578 154.2 465.596C154.268 466.269 154.354 466.939 154.458 467.606C154.505 467.913 154.563 468.233 154.62 468.573L154.612 468.581C154.624 468.59 154.624 468.596 154.624 468.6L154.649 468.734C154.674 468.869 154.699 469.007 154.726 469.145L154.816 469.606L154.863 469.847C154.98 470.424 155.107 470.998 155.244 471.57C155.319 471.889 155.399 472.22 155.483 472.559C155.564 472.88 155.649 473.211 155.74 473.553C155.82 473.855 155.906 474.165 155.993 474.484C155.995 474.499 156.003 474.514 156.005 474.53C156.098 474.859 156.193 475.188 156.289 475.517L156.329 475.662C156.394 475.88 156.461 476.106 156.531 476.333C156.448 476.299 156.367 476.261 156.287 476.22L156.129 475.675C156.112 475.611 156.094 475.552 156.077 475.488L156.075 475.485L156.072 475.483C155.999 475.233 155.93 474.977 155.858 474.72C155.839 474.647 155.821 474.575 155.8 474.5L155.539 473.519C155.455 473.201 155.377 472.881 155.297 472.557C155.219 472.232 155.143 471.907 155.066 471.58C154.989 471.246 154.915 470.914 154.845 470.578C154.774 470.248 154.711 469.913 154.645 469.584C154.583 469.26 154.524 468.935 154.469 468.609C154.466 468.598 154.464 468.584 154.461 468.575L154.464 468.573C154.417 468.251 154.368 467.931 154.319 467.615C154.273 467.281 154.231 466.946 154.191 466.611C154.114 465.944 154.066 465.274 154.048 464.603L153.031 464.111C153.028 464.173 153.023 464.236 153.02 464.303C153.01 464.548 153.004 464.807 153.001 465.078C152.999 465.399 153 465.721 153.006 466.042C153.014 466.351 153.027 466.671 153.044 466.999C153.06 467.279 153.079 467.561 153.102 467.851L153.104 467.883L153.109 467.886C153.111 467.906 153.114 467.928 153.114 467.95C153.141 468.256 153.167 468.565 153.203 468.879C153.269 469.472 153.353 470.062 153.455 470.65C153.464 470.703 153.475 470.759 153.484 470.812C153.603 471.464 153.756 472.109 153.94 472.745C153.999 472.943 154.057 473.132 154.115 473.312C154.168 473.464 154.224 473.616 154.277 473.766C154.406 474.118 154.549 474.46 154.704 474.793L154.709 474.796C154.713 474.811 154.719 474.825 154.725 474.838C154.913 475.242 155.121 475.63 155.354 476C155.363 476.011 155.371 476.028 155.379 476.04C155 475.887 154.33 475.958 154.335 475.959C155.027 476.199 155.633 476.492 156.015 476.938C155.863 477.105 155.579 477.231 155.221 477.335C155.716 477.389 155.991 477.303 156.092 477.259C155.834 477.475 155.689 477.869 155.563 478.292C155.854 477.817 156.143 477.501 156.424 477.38C156.489 477.595 156.559 477.817 156.627 478.037C155.987 479.291 155.37 480.557 154.774 481.832C154.85 481.822 154.923 481.793 154.986 481.747C155.048 481.702 155.098 481.642 155.132 481.572C155.24 481.337 155.824 480.093 156.722 478.343C157.066 479.429 157.455 480.575 157.877 481.767C157.919 481.713 157.947 481.649 157.958 481.581C157.969 481.514 157.963 481.444 157.94 481.38C157.555 480.291 157.192 479.195 156.85 478.092C156.979 477.843 157.114 477.582 157.254 477.315C157.358 477.349 157.466 477.394 157.578 477.445C157.747 477.6 157.871 477.854 157.979 478.145C158.01 477.815 157.91 477.486 157.701 477.23C158.814 477.445 159.824 477.305 160.44 476.555C160.496 476.485 160.55 476.413 160.6 476.34C160.329 476.593 160.032 476.676 159.506 476.567C160.336 476.333 160.775 476.053 161.202 475.55C161.302 475.43 161.405 475.298 161.511 475.15C160.725 475.752 159.905 475.835 159.094 475.561L159.057 475.546C159.819 475.563 160.893 475.151 161.633 474.555C161.975 474.28 162.297 473.947 162.608 473.547C162.842 473.248 163.067 472.914 163.292 472.534C163.487 472.206 163.682 471.847 163.875 471.456C163.676 471.522 163.468 471.56 163.258 471.57L163.138 471.577C163.098 471.579 163.061 471.577 163.017 471.579C163.754 471.414 164.267 470.962 164.678 470.373C164.478 470.47 164.155 470.591 163.787 470.62C163.738 470.625 163.687 470.625 163.635 470.625C163.624 470.624 163.612 470.625 163.596 470.624C163.851 470.559 164.074 470.475 164.271 470.366C164.374 470.307 164.474 470.241 164.569 470.17C164.606 470.139 164.643 470.111 164.678 470.081C164.76 470.01 164.838 469.931 164.911 469.842C164.934 469.814 164.958 469.79 164.978 469.76C165.008 469.719 165.038 469.679 165.064 469.639C165.219 469.417 165.361 469.187 165.489 468.949C165.502 468.923 165.516 468.901 165.528 468.875C165.561 468.805 165.594 468.742 165.619 468.686C165.654 468.604 165.681 468.537 165.696 468.488C165.668 468.506 165.638 468.52 165.606 468.53C165.378 468.624 165 468.686 164.701 468.698C164.698 468.698 164.694 468.698 164.69 468.701H164.634C165.234 468.523 165.523 468.326 165.819 468.02C166.166 467.645 166.487 467.247 166.781 466.83C167.001 466.521 167.202 466.215 167.358 465.936C167.449 465.776 167.532 465.612 167.606 465.443C167.661 465.312 167.708 465.189 167.749 465.068C167.361 465.076 166.928 465.077 166.516 465.068C166.928 465.076 167.362 465.074 167.753 465.064C168.169 463.826 167.805 463.179 167.805 463.179C167.805 463.179 167.367 462.169 166.638 462.47C166.283 462.616 165.662 463.078 164.903 463.77L165.331 464.978C165.774 464.502 166.248 464.056 166.75 463.643C166.536 463.826 166.078 464.248 165.404 465.013C165.191 465.255 164.957 465.533 164.701 465.844C164.687 465.861 164.672 465.876 164.662 465.894C164.183 466.489 163.72 467.097 163.273 467.716C163.067 468 162.858 468.303 162.636 468.623H162.623C162.624 468.64 162.619 468.646 162.614 468.65L162.53 468.776C162.443 468.905 162.353 469.035 162.265 469.168L161.972 469.613C161.921 469.688 161.868 469.764 161.817 469.844C161.663 470.079 161.511 470.321 161.352 470.571C160.946 471.215 160.549 471.865 160.162 472.52C159.78 473.165 159.408 473.816 159.044 474.472C159.034 474.486 159.028 474.505 159.016 474.52C158.829 474.859 158.644 475.198 158.459 475.539L158.379 475.69C158.237 475.955 158.09 476.225 157.945 476.505C157.945 476.509 157.941 476.512 157.94 476.516C157.919 476.556 157.899 476.594 157.88 476.634C157.783 476.819 157.699 476.987 157.505 477.359C157.446 477.301 157.381 477.25 157.311 477.207L157.599 476.665C157.638 476.591 157.679 476.518 157.718 476.44L157.751 476.376L158.206 475.542L158.314 475.348V475.343L158.314 475.338C158.454 475.08 158.601 474.821 158.747 474.555C158.789 474.482 158.832 474.41 158.874 474.334C159.061 474.005 159.253 473.672 159.444 473.336C160.016 472.35 160.609 471.376 161.224 470.416C161.429 470.095 161.643 469.775 161.852 469.456C161.928 469.341 162.003 469.23 162.084 469.115C162.217 468.919 162.35 468.724 162.484 468.53C162.49 468.52 162.5 468.51 162.506 468.5H162.511C162.728 468.203 162.942 467.906 163.155 467.612C163.387 467.301 163.617 467 163.847 466.704C164.315 466.106 164.809 465.529 165.328 464.975L164.898 463.77C164.848 463.817 164.793 463.866 164.738 463.918C164.525 464.117 164.314 464.32 164.107 464.526C163.861 464.771 163.609 465.031 163.347 465.305C162.88 465.803 162.426 466.314 161.987 466.836L161.962 466.864L161.963 466.871C161.949 466.887 161.936 466.907 161.918 466.924C161.697 467.193 161.47 467.465 161.251 467.745C160.833 468.274 160.431 468.816 160.047 469.37C160.011 469.42 159.976 469.475 159.941 469.525C159.519 470.144 159.129 470.785 158.772 471.444C158.664 471.65 158.559 471.848 158.464 472.04C158.384 472.202 158.308 472.369 158.232 472.532C158.057 472.918 157.9 473.307 157.76 473.698L157.762 473.703C157.753 473.718 157.746 473.735 157.74 473.751C157.65 474.004 157.571 474.258 157.499 474.513C157.382 474.658 157.247 474.784 157.096 474.896C157.061 474.853 157.024 474.81 156.987 474.769C157.355 474.216 157.59 473.585 157.674 472.926C157.717 472.514 157.713 472.098 157.66 471.686C157.622 471.353 157.555 471.003 157.462 470.625C157.381 470.297 157.281 469.95 157.159 469.585C157.084 469.739 156.976 469.89 156.844 470.039L156.772 470.117C156.748 470.144 156.722 470.167 156.695 470.195C157.057 469.634 157.1 469.031 156.994 468.405C156.901 468.664 156.763 468.904 156.585 469.114C156.558 469.145 156.525 469.178 156.494 469.21C156.485 469.216 156.478 469.225 156.466 469.234C156.586 469.034 156.674 468.845 156.731 468.652C156.745 468.612 156.756 468.572 156.764 468.53C156.777 468.468 156.788 468.406 156.796 468.343L156.811 468.221C156.819 468.123 156.818 468.024 156.809 467.926C156.807 467.893 156.806 467.863 156.801 467.832C156.793 467.786 156.788 467.745 156.779 467.704C156.739 467.468 156.685 467.234 156.618 467.004C156.609 466.981 156.605 466.957 156.596 466.934C156.574 466.868 156.556 466.81 156.536 466.76C156.514 466.7 156.489 466.642 156.461 466.586C156.455 466.614 156.445 466.642 156.432 466.669C156.347 466.869 156.149 467.144 155.968 467.336C155.965 467.338 155.962 467.34 155.962 467.344L155.929 467.38C156.194 466.896 156.254 466.591 156.249 466.215C156.235 465.764 156.19 465.314 156.116 464.869C156.068 464.559 156.003 464.252 155.923 463.949C155.881 463.791 155.83 463.636 155.773 463.484C155.729 463.374 155.681 463.265 155.629 463.158L155.631 463.155C155.123 462.116 154.493 461.936 154.493 461.936C154.493 461.936 154.267 461.844 154.007 461.833ZM156.824 474.985L156.85 475.054V475.055C156.8 475.083 156.754 475.111 156.702 475.136C156.692 475.14 156.682 475.146 156.669 475.151C156.724 475.099 156.776 475.043 156.824 474.985L156.824 474.985ZM156.321 476.34C156.429 476.454 156.529 476.542 156.616 476.607L156.674 476.796C156.605 476.806 156.537 476.821 156.469 476.84L156.444 476.759C156.424 476.689 156.404 476.617 156.381 476.545L156.364 476.484L156.321 476.34ZM156.538 477.07C156.613 477.068 156.688 477.071 156.764 477.078L156.822 477.269C156.89 477.257 156.959 477.256 157.028 477.265L156.756 477.788C156.682 477.549 156.61 477.309 156.538 477.07Z"
              fill="#092F45"
            />
            <text
              fill="#092F45"
              fontFamily="var(--font-family-body)"
              fontSize="16"
              letterSpacing="0.005em"
            >
              <tspan x="183.952" y="476.472">
                http
              </tspan>
            </text>
            <text
              fill="#5F7886"
              fontFamily="var(--font-family-mono)"
              fontSize="14"
              letterSpacing="0.0075em"
            >
              <tspan x="218.952" y="476.732">
                @0.6.1
              </tspan>
            </text>
            <path
              opacity="0.9"
              d="M151.469 616.684C150.655 616.684 150 617.339 150 618.153V635.214C150 636.029 150.655 636.684 151.469 636.684H168.531C169.345 636.684 170 636.029 170 635.214V618.153C170 617.339 169.345 616.684 168.531 616.684H151.469ZM154.275 621.119L165.806 621.135L165.798 632.665H162.912L162.92 624.014H160.04L160.033 632.659H154.261L154.275 621.119Z"
              fill="#092F45"
            />
            <rect x="118" y="568" width="16" height="16" rx="4" fill="white" />
            <rect
              x="118.5"
              y="568.5"
              width="15"
              height="15"
              rx="3.5"
              stroke="#092F45"
              strokeOpacity="0.1"
              fill="white"
            />
            <rect x="118" y="515" width="16" height="16" rx="4" fill="white" />
            <rect
              x="118.5"
              y="515.5"
              width="15"
              height="15"
              rx="3.5"
              stroke="#092F45"
              strokeOpacity="0.1"
              fill="white"
            />
            <rect x="118" y="464" width="16" height="16" rx="4" fill="white" />
            <rect
              x="118.5"
              y="464.5"
              width="15"
              height="15"
              rx="3.5"
              stroke="#092F45"
              strokeOpacity="0.1"
              fill="white"
            />
            <rect x="118" y="619" width="16" height="16" rx="4" fill="white" />
            <rect
              x="118.5"
              y="619.5"
              width="15"
              height="15"
              rx="3.5"
              stroke="#092F45"
              strokeOpacity="0.1"
              fill="white"
            />
            <rect
              x="689"
              y="512"
              width="36"
              height="23"
              rx="4"
              fill="#EAF1FC"
            />
            <text
              fill="#2A6FE1"
              fontFamily="var(--font-family-mono)"
              fontSize="10"
              letterSpacing="0.04em"
            >
              <tspan x="697.445" y="527">
                gem
              </tspan>
            </text>
            <rect
              x="733"
              y="512"
              width="42"
              height="23"
              rx="4"
              fill="#EAF1FC"
            />
            <text
              fill="#2A6FE1"
              fontFamily="var(--font-family-mono)"
              fontSize="10"
              letterSpacing="0.04em"
            >
              <tspan x="741.193" y="527">
                ruby
              </tspan>
            </text>
            <rect
              x="783"
              y="512"
              width="55"
              height="23"
              rx="4"
              fill="#EAF1FC"
            />
            <text
              fill="#2A6FE1"
              fontFamily="var(--font-family-mono)"
              fontSize="10"
              letterSpacing="0.04em"
            >
              <tspan x="791.189" y="527">
                latest
              </tspan>
            </text>
            <rect
              x="846"
              y="512"
              width="55"
              height="23"
              rx="4"
              fill="#EAF1FC"
            />
            <text
              fill="#2A6FE1"
              fontFamily="var(--font-family-mono)"
              fontSize="10"
              letterSpacing="0.04em"
            >
              <tspan x="854.189" y="527">
                server
              </tspan>
            </text>
            <rect
              x="909"
              y="512"
              width="55"
              height="23"
              rx="4"
              fill="#EAF1FC"
            />
            <text
              fill="#2A6FE1"
              fontFamily="var(--font-family-mono)"
              fontSize="10"
              letterSpacing="0.04em"
            >
              <tspan x="917.189" y="527">
                produc
              </tspan>
            </text>
            <rect
              x="689"
              y="564"
              width="36"
              height="23"
              rx="4"
              fill="#EAF1FC"
            />
            <text
              fill="#2A6FE1"
              fontFamily="var(--font-family-mono)"
              fontSize="10"
              letterSpacing="0.04em"
            >
              <tspan x="697.445" y="579">
                gem
              </tspan>
            </text>
            <rect
              x="733"
              y="564"
              width="42"
              height="23"
              rx="4"
              fill="#EAF1FC"
            />
            <text
              fill="#2A6FE1"
              fontFamily="var(--font-family-mono)"
              fontSize="10"
              letterSpacing="0.04em"
            >
              <tspan x="741.193" y="579">
                ruby
              </tspan>
            </text>
            <rect
              x="783"
              y="564"
              width="55"
              height="23"
              rx="4"
              fill="#EAF1FC"
            />
            <text
              fill="#2A6FE1"
              fontFamily="var(--font-family-mono)"
              fontSize="10"
              letterSpacing="0.04em"
            >
              <tspan x="791.189" y="579">
                latest
              </tspan>
            </text>
            <rect
              x="846"
              y="564"
              width="55"
              height="23"
              rx="4"
              fill="#EAF1FC"
            />
            <text
              fill="#2A6FE1"
              fontFamily="var(--font-family-mono)"
              fontSize="10"
              letterSpacing="0.04em"
            >
              <tspan x="854.189" y="579">
                server
              </tspan>
            </text>
            <rect
              x="689"
              y="616"
              width="36"
              height="23"
              rx="4"
              fill="#EAF1FC"
            />
            <text
              fill="#2A6FE1"
              fontFamily="var(--font-family-mono)"
              fontSize="10"
              letterSpacing="0.04em"
            >
              <tspan x="697.445" y="631">
                gem
              </tspan>
            </text>
            <rect
              x="733"
              y="616"
              width="42"
              height="23"
              rx="4"
              fill="#EAF1FC"
            />
            <text
              fill="#2A6FE1"
              fontFamily="var(--font-family-mono)"
              fontSize="10"
              letterSpacing="0.04em"
            >
              <tspan x="741.193" y="631">
                ruby
              </tspan>
            </text>
            <rect
              x="783"
              y="616"
              width="55"
              height="23"
              rx="4"
              fill="#EAF1FC"
            />
            <text
              fill="#2A6FE1"
              fontFamily="var(--font-family-mono)"
              fontSize="10"
              letterSpacing="0.04em"
            >
              <tspan x="791.189" y="631">
                latest
              </tspan>
            </text>
            <rect
              x="846"
              y="616"
              width="55"
              height="23"
              rx="4"
              fill="#EAF1FC"
            />
            <text
              fill="#2A6FE1"
              fontFamily="var(--font-family-mono)"
              fontSize="10"
              letterSpacing="0.04em"
            >
              <tspan x="854.189" y="631">
                server
              </tspan>
            </text>
            <path
              d="M689 465C689 462.239 691.239 460 694 460H750C752.761 460 755 462.239 755 465V478C755 480.761 752.761 483 750 483H694C691.239 483 689 480.761 689 478V465Z"
              fill="#2A6FE1"
              fillOpacity="0.1"
            />
            <text
              fill="#2A6FE1"
              fontFamily="var(--font-family-mono)"
              fontSize="11"
              letterSpacing="0.04em"
            >
              <tspan x="697.181" y="475.35">
                PENDING
              </tspan>
            </text>
            <line x1="95" y1="410.5" x2="975" y2="410.5" stroke="#E2E7EA" />
            <text
              opacity="0.5"
              fill="#092F45"
              fontFamily="var(--font-family-mono)"
              fontSize="11"
              letterSpacing="0em"
            >
              <tspan x="151" y="432.85">
                PACKAGES
              </tspan>
            </text>
            <text
              opacity="0.5"
              fill="#092F45"
              fontFamily="var(--font-family-mono)"
              fontSize="11"
              letterSpacing="0em"
            >
              <tspan x="689" y="432.85">
                TAGS
              </tspan>
            </text>
            <rect
              x="953"
              y="508"
              width="11"
              height="30"
              fill="url(#paint0_linear_3584_7073)"
            />
            <text
              fill="black"
              fontFamily="var(--font-family-headline)"
              fontSize="24"
              letterSpacing="0.01em"
            >
              <tspan x="117.918" y="204.4">
                Repository
              </tspan>
            </text>
            <g clipPath="url(#clip1_3584_7073)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M100.691 191.047H102.063H102.19H103.563L104.286 191.839L104.286 194.02H105.398L106.693 195.446V196.514V199.118V200.185L105.398 201.612H98.8561L97.561 200.185V199.118V196.514V195.446L98.8561 194.02H99.9673L99.9673 191.839L100.691 191.047ZM105.693 195.833V196.514V199.118V199.799L104.955 200.612H99.2989L98.561 199.799V199.118V196.514V195.833L99.2989 195.02H104.955L105.693 195.833ZM100.967 194.02H103.286L103.286 192.227L103.122 192.047L102.19 192.047H102.063L101.132 192.047L100.967 192.227L100.967 194.02ZM101.69 196.514V199.222H102.69V196.514H101.69Z"
                fill="#5F7886"
              />
            </g>
            <text
              fill="#092F45"
              fontFamily="var(--font-family-mono)"
              fontSize="12"
              letterSpacing="0.0075em"
            >
              <tspan x="297" y="203.2">
                760
              </tspan>
            </text>
            <text
              fill="#8497A2"
              fontFamily="var(--font-family-mono)"
              fontSize="11"
              letterSpacing="0.015em"
            >
              <tspan x="324" y="202.85">
                Packages
              </tspan>
            </text>
            <text
              fill="#092F45"
              fontFamily="var(--font-family-mono)"
              fontSize="12"
              letterSpacing="0.0075em"
            >
              <tspan x="395" y="203.2">
                123
              </tspan>
            </text>
            <text
              fill="#8497A2"
              fontFamily="var(--font-family-mono)"
              fontSize="11"
              letterSpacing="0.015em"
            >
              <tspan x="422" y="202.85">
                MB
              </tspan>
            </text>
            <text
              fill="#092F45"
              fontFamily="var(--font-family-mono)"
              fontSize="12"
              letterSpacing="0.0075em"
            >
              <tspan x="452" y="203.2">
                1,123,412
              </tspan>
            </text>
            <text
              fill="#8497A2"
              fontFamily="var(--font-family-mono)"
              fontSize="11"
              letterSpacing="0.015em"
            >
              <tspan x="523" y="202.85">
                Downloads
              </tspan>
            </text>
            <text
              fill="#8497A2"
              fontFamily="var(--font-family-mono)"
              fontSize="11"
              letterSpacing="0.02em"
            >
              <tspan x="601.408" y="202.85">
                Read-only
              </tspan>
            </text>
            <rect
              x="822"
              y="17"
              width="152"
              height="643"
              fill="url(#paint1_linear_3584_7073)"
            />
            <rect
              x="974"
              y="508"
              width="152"
              height="941"
              transform="rotate(90 974 508)"
              fill="url(#paint2_linear_3584_7073)"
            />
            <rect
              x="973.5"
              y="-41"
              width="701"
              height="100"
              transform="rotate(90 973.5 -41)"
              fill="url(#paint3_linear_3584_7073)"
            />
          </g>
        </g>
      </g>
      <defs>
        <filter
          id="filter0_d_3584_7073"
          x="0"
          y="0"
          width="1005"
          height="705"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="15" />
          <feGaussianBlur stdDeviation="15" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.498039 0 0 0 0 0.145098 0 0 0 0 0.121569 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_3584_7073"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_3584_7073"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_3584_7073"
          x1="953"
          y1="523"
          x2="964"
          y2="523"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_3584_7073"
          x1="822"
          y1="338.5"
          x2="974"
          y2="338.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_3584_7073"
          x1="974"
          y1="978.5"
          x2="1126"
          y2="978.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_3584_7073"
          x1="1324"
          y1="-41"
          x2="1324"
          y2="59"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B8463C" stopOpacity="0.1" />
          <stop offset="1" stopColor="#B8463C" stopOpacity="0" />
        </linearGradient>
        <clipPath id="clip0_3584_7073">
          <rect
            width="945"
            height="645"
            fill="white"
            transform="translate(30 15)"
          />
        </clipPath>
        <clipPath id="clip1_3584_7073">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(94 188.577)"
          />
        </clipPath>
      </defs>
    </Explainer>
  );
};

export default UniversalFormat;
